import React, { memo } from 'react';

export const LocationSection = memo(({ address, location, onOpenPicker }) => {
  return (
    <div className="form-section">
      <label className="section-label">Location *</label>
      <div className="location-picker-container">
        <div className="location-display" onClick={onOpenPicker}>
          <div className="location-content">
            <div className="location-text-group">
              <span className="location-icon-wrapper">
                <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="#26B8E3" strokeWidth="2.5" strokeLinecap="round" strokeLinejoin="round">
                  <path d="M20 10c0 6-8 12-8 12s-8-6-8-12a8 8 0 0 1 16 0Z" />
                  <circle cx="12" cy="10" r="3" />
                </svg>
              </span>
              <div className="location-text">
                <span className={address ? '' : 'placeholder'}>
                  {address || "Tap to pick location on map"}
                </span>
                {address && location.lat && (
                  <span className="location-coords">
                    Lat: {location.lat.toFixed(6)}, Lng: {location.lng.toFixed(6)}
                  </span>
                )}
              </div>
            </div>
            <span className="chevron">›</span>
          </div>
        </div>
      </div>
    </div>
  );
});

LocationSection.displayName = 'LocationSection';